export default "__VITE_ASSET__BxVw_Dku__"